module.exports = __webpack_public_path__ + "static/media/deals-image-2.fcaf6008.png";